import React from 'react';
import { FormattedMessage } from 'react-intl';
import Box from 'carbon-react/lib/components/box';
import Typography from 'carbon-react/lib/components/typography';
import Divider from 'carbon-react/lib/components/divider';

import { getTimestampRelativeFormat } from '@futrli/localisation';

import styles from './update-from-excel-org-status.scss';
import excelLogo from './img/Excel Logo.png';

interface UpdateFromExcelOrgStatusProps {
  name: string;
  lastSynced: string;
}

export const UpdateFromExcelOrgStatus = ({ name, lastSynced }: UpdateFromExcelOrgStatusProps) => {
  return (
    <Box className={styles.statusCard} mb="24px">
      <Box display="flex" alignItems="center">
        <img src={excelLogo} alt="Excel" width={48} height={48} />
        <Box ml={2}>
          <Typography fontSize="16px" fontWeight="500" mb={0}>
            {name}
          </Typography>
          <Typography fontSize="14px" color=" var(--colors-utility-yin-055, rgba(0, 0, 0, 0.55))" mb={0}>
            <FormattedMessage id="predict.excel_organisation" defaultMessage="Excel Organisation" />
          </Typography>
        </Box>
      </Box>
      <Divider type="horizontal" mt={2} mb={2} />
      <Typography fontSize="14px" color="var(--colors-utility-yin-065, rgba(0, 0, 0, 0.65))" mb={0}>
        <FormattedMessage id="common.last_synced" defaultMessage="Last synced" />
      </Typography>
      <Typography fontSize="14px" fontWeight="500" mb={0}>
        {getTimestampRelativeFormat(lastSynced, Date.now(), 1)}
      </Typography>
    </Box>
  );
};
